import { render, staticRenderFns } from "./OrderResult.vue?vue&type=template&id=79ef9890&scoped=true&"
import script from "./OrderResult.vue?vue&type=script&lang=js&"
export * from "./OrderResult.vue?vue&type=script&lang=js&"
import style0 from "./OrderResult.vue?vue&type=style&index=0&id=79ef9890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ef9890",
  null
  
)

export default component.exports